var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',{attrs:{"custom":("iconfont " + (_vm.iconTypeList[_vm.type])),"size":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }